import { CommodityActionTypes } from './constants';

const GET_COMMODITY_DATA_INITIAL_STATE = {
    commodityData: [],
    loading: false,
};
const CREATE_COMMODITY_DATA_INITIAL_STATE = {
    createCommodityData: [],
    loading: false,
};

const UPDATE_COMMODITY_DATA_INITIAL_STATE = {
    updateCommodityData: [],
    loading: false,
};
const DELETE_COMMODITY_DATA_INITIAL_STATE = {
    deleteCommodityData: [],
    loading: false,
};

const UPLOAD_COMMODITY_DATA_INITIAL_STATE = {
    uploadCommodityData: [],
    loading: false,
};
const commodityDataReducer = (state = GET_COMMODITY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case CommodityActionTypes.COMMODITY_DATA_LOADING:
            return {
                commodityData: state.commodityData,
                loading: true,
            };
        case CommodityActionTypes.COMMODITY_DATA_SUCCESS:
            return {
                commodityData: action.payload,
                loading: false,
            };
        case CommodityActionTypes.COMMODITY_DATA_ERROR:
            return {
                commodityData: action.payload,
                loading: false,
            };
        case CommodityActionTypes.COMMODITY_DATA_RESET:
            return {
                ...GET_COMMODITY_DATA_INITIAL_STATE,
            };
        default:
            return state;
    }
};

const createCommodityDataReducer = (state = CREATE_COMMODITY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case CommodityActionTypes.CREATE_COMMODITY_DATA_LOADING:
            return {
                createCommodityData: state.createCommodityData,
                loading: true,
            };
        case CommodityActionTypes.CREATE_COMMODITY_DATA_SUCCESS:
            return {
                createCommodityData: action.payload,
                loading: false,
            };
        case CommodityActionTypes.CREATE_COMMODITY_DATA_ERROR:
            return {
                createCommodityData: action.payload ,
                loading: false,
            };
        case CommodityActionTypes.STATE_EMPTY_FIRST:
            return {
                ...CREATE_COMMODITY_DATA_INITIAL_STATE,
            };
        default:
            return state;
    }
};

const updateCommodityDataReducer = (state = UPDATE_COMMODITY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case CommodityActionTypes.UPDATE_COMMODITY_DATA_LOADING:
            return {
                updateCommodityData: action.payload,
                loading: true,
            };
        case CommodityActionTypes.UPDATE_COMMODITY_DATA_SUCCESS:
            return {
                updateCommodityData: action.payload,
                loading: false,
            };
        case CommodityActionTypes.UPDATE_COMMODITY_DATA_ERROR:
            return {
                updateCommodityData: action.payload ,
                loading: false,
            };
        case CommodityActionTypes.STATE_EMPTY_FIRST:
            return {
                ...UPDATE_COMMODITY_DATA_INITIAL_STATE,
            };
        default:
            return state;
    }
};

const deleteCommodityDataReducer = (state = DELETE_COMMODITY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case CommodityActionTypes.DELETE_COMMODITY_DATA_LOADING:
            return {
                deleteCommodityData: action.payload,
                loading: true,
            };
        case CommodityActionTypes.DELETE_COMMODITY_DATA_SUCCESS:
            return {
                deleteCommodityData: action.payload,
                loading: false,
            };
        case CommodityActionTypes.DELETE_COMMODITY_DATA_ERROR:
            return {
                deleteCommodityData: action.payload ,
                loading: false,
            };
        case CommodityActionTypes.STATE_EMPTY_FIRST:
            return {
                ...DELETE_COMMODITY_DATA_INITIAL_STATE,
            };
        default:
            return state;
    }
};

const uploadCommodityDataReducer = (state = UPLOAD_COMMODITY_DATA_INITIAL_STATE, action) => {
    switch (action.type) {
        case CommodityActionTypes.UPLOAD_COMMODITY_DATA_LOADING:
            return {
                uploadCommodityData: state.uploadCommodityData,
                loading: true,
            };
        case CommodityActionTypes.UPLOAD_COMMODITY_DATA_SUCCESS:
            return {
                uploadCommodityData: action.payload,
                loading: false,
            };
        case CommodityActionTypes.UPLOAD_COMMODITY_DATA_ERROR:
            return {
                uploadCommodityData: action.payload ,
                loading: false,
            };
        case CommodityActionTypes.STATE_EMPTY_FIRST:
            return {
                ...UPLOAD_COMMODITY_DATA_INITIAL_STATE,
            };
        default:
            return state;
    }
};

export { commodityDataReducer, createCommodityDataReducer, updateCommodityDataReducer, deleteCommodityDataReducer, uploadCommodityDataReducer };
